const EXTERNAL_URL_PATTERN =
  /^(https?:\/\/|www\.|[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z]{2,})+([/?#]|$))/i;

const normalizeExternalUrl = rawUrl => {
  if (typeof rawUrl !== "string") return "";
  const trimmedUrl = rawUrl.trim();
  if (!trimmedUrl) return "";
  return /^https?:\/\//i.test(trimmedUrl) ? trimmedUrl : `https://${trimmedUrl}`;
};

export const isExternalRedirect = rawUrl =>
  typeof rawUrl === "string" && EXTERNAL_URL_PATTERN.test(rawUrl.trim());

export const getInternalPathWithoutQuery = rawPath => {
  if (typeof rawPath !== "string") return rawPath;
  return rawPath.split("?")[0];
};

export const appendAuthTokensToUrl = (
  rawUrl,
  { token, lineToken, memberToken } = {}
) => {
  const url = new URL(normalizeExternalUrl(rawUrl));

  if (token && !url.searchParams.has("token")) {
    url.searchParams.set("token", token);
  }
  if (lineToken && !url.searchParams.has("line_token")) {
    url.searchParams.set("line_token", lineToken);
  }
  if (memberToken && !url.searchParams.has("member_token")) {
    url.searchParams.set("member_token", memberToken);
  }

  return url.toString();
};

